/*! Global AJAX Cart v2 — intercept all add-to-cart forms and show full cart popup */
(function () {
  'use strict';

  // Prevent multiple initializations
  if (window.__AJAX_CART_GLOBAL_INITIALIZED__) return;
  window.__AJAX_CART_GLOBAL_INITIALIZED__ = true;

  // Show full cart popup (matching theme's added-notice)
  function showCartPopup(addedItem) {
    // Get current cart data
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cartData) {
        var theme = window.theme || {};
        var strings = theme.strings || {};
        var icons = theme.icons || {};

        // Build product image
        var productImage = addedItem.image || addedItem.featured_image || '';
        var productQty =
          addedItem.quantity > 1
            ? ' <span class="cart-summary__product-qty">× ' +
              addedItem.quantity +
              '</span>'
            : '';

        // Build variant title if exists
        var variantTitle = '';
        if (
          addedItem.variant_title &&
          addedItem.variant_title !== 'Default Title'
        ) {
          variantTitle =
            '<div class="cart-summary__product-variant">' +
            addedItem.variant_title +
            '</div>';
        }

        // Build price
        var productPrice = addedItem.final_line_price
          ? theme.Shopify && theme.Shopify.formatMoney
            ? theme.Shopify.formatMoney(
                addedItem.final_line_price,
                theme.moneyFormat || '{{amount}}'
              )
            : '£' + (addedItem.final_line_price / 100).toFixed(2)
          : '';

        var html = [
          '<div class="added-notice global-border-radius added-notice--pre-reveal">',
          '<div class="added-notice__header">',
          '<span class="added-notice__title">',
          strings.addedToCartPopupTitle || 'Added to cart',
          '</span>',
          '<a class="added-notice__close feather-icon" href="#" aria-label="',
          strings.close || 'Close',
          '">',
          icons.close || '×',
          '</a>',
          '</div>',
          '<div class="cart-summary global-border-radius">',
          '<div class="cart-summary__product">',
          productImage
            ? '<div class="cart-summary__product-image"><img class="global-border-radius" src="' +
              productImage +
              '" alt=""></div>'
            : '',
          '<div class="cart-summary__product__description">',
          '<div class="cart-summary__product-title">',
          addedItem.product_title || addedItem.title || 'Product',
          productQty,
          '</div>',
          variantTitle,
          '<div class="cart-summary__price">',
          productPrice,
          '</div>',
          '</div>',
          '</div>',
          '</div>',
          '<div class="cart-summary__footer">',
          '<div class="cart-summary__total-quantity-row">',
          '<span>',
          strings.addedToCartPopupItems || 'Items',
          '</span>',
          '<span>',
          cartData.item_count,
          '</span>',
          '</div>',
          '<div class="cart-summary__total-price-row large-text">',
          '<span>',
          strings.addedToCartPopupSubtotal || 'Subtotal',
          '</span>',
          '<span class="theme-money">',
          theme.Shopify && theme.Shopify.formatMoney
            ? theme.Shopify.formatMoney(
                cartData.total_price,
                theme.moneyFormatWithCodeForCartPreference ||
                  theme.moneyFormat ||
                  '{{amount}}'
              )
            : '£' + (cartData.total_price / 100).toFixed(2),
          '</span>',
          '</div>',
          '<a href="',
          (theme.routes && theme.routes.cart_url) || '/cart',
          '" class="btn btn--primary btn--small btn--fullwidth cart-summary__button">',
          strings.addedToCartPopupGoToCart || 'Go to cart',
          '</a>',
          '</div>',
          '</div>',
        ].join('');

        var $template = $(html);
        $template.appendTo('body');

        // Bind close button
        $template.find('.added-notice__close').on('click', function (e) {
          e.preventDefault();
          $template.addClass('added-notice--pre-destroy');
          setTimeout(function () {
            $template.remove();
          }, 500);
          return false;
        });

        // Transition in
        setTimeout(function () {
          $template.removeClass('added-notice--pre-reveal');
        }, 10);

        // Auto-close after 3 seconds
        var autoCloseTimeout = setTimeout(function () {
          $template.find('.added-notice__close').trigger('click');
        }, 3000);

        // Clear auto-close if user hovers over cart
        $('.header-cart').on('mouseenter.cartPopup', function () {
          clearTimeout(autoCloseTimeout);
          $template.find('.added-notice__close').trigger('click');
        });
      })
      .catch(function (err) {
        console.error('Failed to fetch cart data:', err);
      });
  }

  // Update cart count in header
  function updateCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        // Ensure count is always a number (handle null/undefined)
        var count = cart.item_count != null ? cart.item_count : 0;

        // Find all cart count elements
        var countElements = document.querySelectorAll(
          '.header-cart__count, .cart-count, [data-cart-count]'
        );

        if (countElements.length > 0) {
          // Update existing count elements
          countElements.forEach(function (el) {
            el.textContent = count;
            // Also update data attribute if it exists
            if (el.hasAttribute('data-cart-count')) {
              el.setAttribute('data-cart-count', count);
            }
          });
        } else if (count > 0) {
          // If no count elements exist and count > 0, create them
          var headerCarts = document.querySelectorAll('.header-cart a');
          headerCarts.forEach(function (cartLink) {
            // Check if count doesn't already exist in this cart link
            if (!cartLink.querySelector('.header-cart__count')) {
              var countSpan = document.createElement('span');
              countSpan.className = 'header-cart__count';
              countSpan.textContent = count;
              cartLink.appendChild(countSpan);
            }
          });
        }
      })
      .catch(function () {});
  }

  // Handle form submission
  function handleAddToCart(e) {
    var form = e.target;

    // Skip if not a cart add form
    if (
      !form.matches('form[action="/cart/add"]') &&
      !form.matches('form[action*="/cart/add"]')
    ) {
      return;
    }

    // Skip if form already has AJAX handling (has ajax-product-form class)
    if (form.classList.contains('ajax-product-form')) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    // Get form data
    var formData = new FormData(form);
    var data = {};
    formData.forEach(function (value, key) {
      data[key] = value;
    });

    // Disable submit button
    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';
    }

    // Submit via AJAX
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify(data),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(
              err.description || err.message || 'Failed to add to cart'
            );
          });
        }
        return response.json();
      })
      .then(function (item) {
        // Success!
        showCartPopup(item);
        updateCartCount();

        // Re-enable button
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      })
      .catch(function (err) {
        // Error
        var errorMsg = err.message || 'Failed to add to cart';
        alert(errorMsg);
        console.error('Add to cart error:', err);

        // Re-enable button
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      });
  }

  // Intercept all form submissions
  document.addEventListener('submit', handleAddToCart, true);

  console.log('[AJAX Cart] Global cart interceptor initialized');
})();
